// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__VW8NO","web_layout":"styles_web_layout__WNleZ"};